import styled, { css, keyframes } from 'styled-components';
import { FlexCenterAligned } from '../../styled/common';

const rotation = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const LoaderContainer = styled(FlexCenterAligned)<{
  $pageLoader?: boolean;
  $endless?: boolean;
  $minHeight?: number;
}>`
  ${({ $pageLoader }) =>
    $pageLoader &&
    css`
      position: fixed;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.75);
      margin: 0;
      z-index: 10;
    `};

  ${({ $endless }) =>
    $endless &&
    css`
      padding: 10px 0;
    `};

  ${({ $minHeight }) =>
    $minHeight &&
    css`
      min-height: ${$minHeight}px;
      align-items: flex-start;
      padding-top: 20px;
    `};
`;

export const LoaderSpinner = styled.span`
  opacity: 0.75;
  vertical-align: middle;
  width: 27px;
  height: 27px;
  border-radius: 50%;
  border-top: 2px solid transparent;
  border-right: 2px solid #946952;
  border-bottom: 2px solid #946952;
  border-left: 2px solid #946952;
  transform: translateZ(0);
  animation: ${rotation} 1s infinite linear;
`;
